export default __webpack_public_path__ + "static/media/minigame_banner_4.762199b9.png";